// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p {\n    color: white;\n}\np.MuiTypography-body1 {\n    color: rgb(37, 37, 37);\n}", "",{"version":3,"sources":["webpack://src/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B","sourcesContent":["p {\n    color: white;\n}\np.MuiTypography-body1 {\n    color: rgb(37, 37, 37);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
